import { render, staticRenderFns } from "./shanxiSupervisonInstitutionalStatistics.vue?vue&type=template&id=3d76f4b5"
import script from "./shanxiSupervisonInstitutionalStatistics.vue?vue&type=script&lang=js"
export * from "./shanxiSupervisonInstitutionalStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports